import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

import { IconComponent } from '../icon/icon';

/**
 * Marks content the AI wrote or judged, wherever it appears. Put it beside the
 * content's heading or label — once per block, and on a table's column header
 * rather than on every row.
 *
 * It says who produced the content and nothing else: an engine figure worked out
 * from AI-read inputs is not marked, and nor is a mention of AI (consent, cost).
 */
@Component({
  selector: 'app-ai-mark',
  imports: [MatTooltipModule, IconComponent],
  template: `<span
    class="ai-mark"
    role="img"
    tabindex="0"
    aria-label="AI-generated"
    matTooltip="Generated by AI. A person makes the final decision."
    data-testid="ai-mark"
  >
    <app-icon name="bot" [size]="14" />
    @if (!iconOnly()) {
      <span aria-hidden="true">AI</span>
    }
  </span>`,
  styles: `
    :host {
      display: inline-flex;
      vertical-align: middle;
    }
    .ai-mark {
      display: inline-flex;
      align-items: center;
      gap: var(--space-1);
      padding: 0 var(--space-1);
      border: 1px solid var(--color-info-border);
      border-radius: var(--radius-sm);
      background: var(--color-info-bg);
      color: var(--color-info-text);
      font-size: var(--font-size-xs);
      font-weight: 600;
      line-height: 1.25rem;
    }
    .ai-mark:focus-visible {
      outline: 2px solid var(--focus-ring-color);
      outline-offset: 2px;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiMarkComponent {
  /** The robot alone, for tight spots. The accessible name is unchanged. */
  readonly iconOnly = input(false);
}
